var exports = {
  "or": "VoiceParticipantTile.module__cursorPointer___aEhZcj",
  "yy": "VoiceParticipantTile.module__watchStreamOverlay___aEhZcj",
  "R6": "VoiceParticipantTile.module__watchStreamButtons___aEhZcj",
  "kV": "VoiceParticipantTile.module__watchStreamButton___aEhZcj",
  "LY": "VoiceParticipantTile.module__watchStreamButtonLabel___aEhZcj",
  "MO": "VoiceParticipantTile.module__watchStreamSecondaryButton___aEhZcj",
  "gk": "VoiceParticipantTile.module__streamInfoHud___aEhZcj",
  "FI": "VoiceParticipantTile.module__streamEndedOverlay___aEhZcj",
  "Zz": "VoiceParticipantTile.module__screenShareBufferingFrame___aEhZcj",
  "Wo": "VoiceParticipantTile.module__streamEndedContent___aEhZcj",
  "$k": "VoiceParticipantTile.module__streamEndedTitle___aEhZcj",
  "BL": "VoiceParticipantTile.module__streamEndedButton___aEhZcj",
  "Ec": "VoiceParticipantTile.module__avatarRing___aEhZcj",
  "Gi": "VoiceParticipantTile.module__avatarRingSpeaking___aEhZcj",
  "kA": "VoiceParticipantTile.module__tileAvatarRing___aEhZcj",
  "z3": "VoiceParticipantTile.module__focusOverlay___aEhZcj",
  "gD": "VoiceParticipantTile.module__focusOverlayIcon___aEhZcj",
  "CT": "VoiceParticipantTile.module__mirroredVideo___aEhZcj",
  "yI": "VoiceParticipantTile.module__videoDisabledOverlay___aEhZcj",
  "xS": "VoiceParticipantTile.module__videoDisabledIcon___aEhZcj",
  "if": "VoiceParticipantTile.module__participantIconMuted___aEhZcj",
  "Yc": "VoiceParticipantTile.module__participantIconRed___aEhZcj",
  "io": "VoiceParticipantTile.module__participantIconWhite___aEhZcj",
  "Gl": "VoiceParticipantTile.module__participantNameText___aEhZcj",
  "Zi": "VoiceParticipantTile.module__participantConnectionText___aEhZcj",
  "P4": "VoiceParticipantTile.module__tilePillIcon___aEhZcj",
  "cj": "VoiceParticipantTile.module__streamAudioSlotMuted___aEhZcj",
  "Sr": "VoiceParticipantTile.module__avatarFlexShrink___aEhZcj",
  "iW": "VoiceParticipantTile.module__previewPopover___aEhZcj",
  "OG": "VoiceParticipantTile.module__frozenFrame___aEhZcj",
  "Wz": "VoiceParticipantTile.module__dimmedLastFrame___aEhZcj",
  "xR": "VoiceParticipantTile.module__cornerBufferingIndicator___aEhZcj",
  "kJ": "VoiceParticipantTile.module__screensharePreviewBackground___aEhZcj",
  "A": "VoiceParticipantTile.module__streamPreviewUnavailableSurface___aEhZcj",
  "Ae": "VoiceParticipantTile.module__focusedPlaceholderScreenSurface___aEhZcj",
  "SQ": "VoiceParticipantTile.module__focusedPlaceholderCameraOverlay___aEhZcj",
  "xh": "VoiceParticipantTile.module__focusedPlaceholderIconLayer___aEhZcj",
  "Iy": "VoiceParticipantTile.module__focusedPlaceholderIcon___aEhZcj",
  "uA": "VoiceParticipantTile.module__focusedPlaceholderLiveBadge___aEhZcj",
  "mf": "VoiceParticipantTile.module__focusedPlaceholderAvatarDimmed___aEhZcj",
  "vB": "VoiceParticipantTile.module__selfStreamOverlay___aEhZcj",
  "Ft": "VoiceParticipantTile.module__paused___aEhZcj",
  "xz": "VoiceParticipantTile.module__selfStreamPreviewPaused___aEhZcj",
  "ck": "VoiceParticipantTile.module__pausedIcon___aEhZcj",
  "Ok": "VoiceParticipantTile.module__pausedText___aEhZcj",
  "I5": "VoiceParticipantTile.module__pausedSubtext___aEhZcj",
  "AS": "VoiceParticipantTile.module__watchStreamPrimaryButton___aEhZcj",
  "DE": "VoiceParticipantTile.module__groupExpandPillSlot___aEhZcj",
  "GX": "VoiceParticipantTile.module__groupExpandPillSign___aEhZcj",
};

module.exports = exports;
